<template>
    <div class="main">
        <el-dialog
            :title="openData.title"
            :visible.sync="openData.state"
            :close-on-click-modal="false"
            width="700px"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    :disabled="openData.title == '详情'"
                    label-position="left"
                    label-width="110px"
                    ref="formData"
                    :model="formData"
                    :rules="formDataRules"
                >
                    <el-form-item label="业务大类别：" prop="bigCategoryId">
                        <el-select
                            v-model="formData.bigCategoryId"
                            placeholder="请选择类别"
                            @change="changeBig"
                            style="width: 100%"
                        >
                            <!-- orgList -->
                            <el-option
                                v-for="item in orgList"
                                :key="item.id"
                                :label="item.businessName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="业务小类别：" prop="smallCategoryId">
                        <el-select
                            v-model="formData.smallCategoryId"
                            placeholder="请选择类别"
                            style="width: 100%"
                        >
                            <!-- orgList -->
                            <el-option
                                v-for="item in selectData"
                                :key="item.id"
                                :label="item.businessName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="标题：" prop="title">
                        <el-input
                            v-model.trim="formData.title"
                            placeholder="请输入标题"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="问题：" prop="question">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 2 }"
                            v-model.trim="formData.question"
                            placeholder="请输入问题"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="答案：" prop="answer">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 2 }"
                            v-model.trim="formData.answer"
                            placeholder="请输入答案"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="录入时间：" prop="inputDate">
                        <el-date-picker
                            v-model="formData.inputDate"
                            type="date"
                            style="width: 100%"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="录入时间"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="备注：" prop="remark">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 2 }"
                            v-model.trim="formData.remark"
                            placeholder="请输入备注"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div
                slot="footer"
                class="dialog-footer dialog-footer-btn"
                v-if="openData.title != '详情'"
            >
                <el-button type="primary" @click="handleSubmit"
                    >确 定</el-button
                >
                <el-button @click="dialogVisibleClone">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ["openData"],

    data() {
        return {
            formData: {
                bigCategoryId: "",
                smallCategoryId: "",
                title: "",
                question: "",
                answer: "",
                inputDate: "",
                remark: "",
            },
            formDataRules: {
                bigCategoryId: [
                    {
                        required: true,
                        message: "业务大类不能为空",
                        trigger: "blur",
                    },
                ],
                smallCategoryId: [
                    {
                        required: true,
                        message: "业务小类不能为空",
                        trigger: "blur",
                    },
                ],
                title: [
                    {
                        required: true,
                        message: "标题不能为空",
                        trigger: "blur",
                    },
                ],
                question: [
                    {
                        required: true,
                        message: "问题不能为空",
                        trigger: "blur",
                    },
                ],
                answer: [
                    {
                        required: true,
                        message: "答案不能为空",
                        trigger: "blur",
                    },
                ],
                inputDate: [
                    {
                        required: true,
                        message: "创建时间不能为空",
                        trigger: "blur",
                    },
                ],
                remark: [
                    {
                        required: true,
                        message: "备注不能为空",
                        trigger: "blur",
                    },
                ],
            },
            // 大类
            orgList: [],
            // 小类
            selectData: [],
        }
    },
    created() {
        this.formData = {
            bigCategoryId: "",
            smallCategoryId: "",
            title: "",
            question: "",
            answer: "",
            inputDate: "",
            remark: "",
        }

        this.getVersion()
    },
    methods: {
        getVersion() {
            let params = {}
            this.$http
                .request({
                    url:
                        "/ypt/admin/businessDatabaseCategory/info/BusinessDatabaseCategoryTree",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.orgList = []
                            return
                        }
                        this.orgList = res.content
                        if (this.openData.title != "新增") {
                            this.getData()
                        }
                    }
                })
        },
        // 获取小类
        changeBig(data) {
            this.selectData = []
            this.orgList.forEach((item) => {
                if (item.id == data) {
                    this.selectData = item.children
                }
            })
        },
        // 详情获取
        getData() {
            const self = this
            let params = {
                id: self.openData.id,
            }
            this.$http
                .request({
                    url: "/ypt/admin/businessDatabase/info/get",
                    method: "POST",
                    data: params,
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        let jsonTemp = { ...res.content }
                        self.orgList.forEach((item) => {
                            if (item.id == jsonTemp.bigCategoryId) {
                                self.selectData = item.children
                            }
                        })
                        self.formData.id = jsonTemp.id
                        self.formData.title = jsonTemp.title
                        self.formData.bigCategoryId = jsonTemp.bigCategoryId
                        self.formData.smallCategoryId = jsonTemp.smallCategoryId
                        self.formData.question = jsonTemp.question
                        self.formData.answer = jsonTemp.answer
                        self.formData.inputDate = jsonTemp.inputDate
                        self.formData.remark = jsonTemp.remark
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        handleSubmit() {
            let self = this

            this.$refs.formData.validate((valid) => {
                if (valid) {
                    if (
                        this.openData.title == "新增" ||
                        this.openData.title == "编辑"
                    ) {
                        let url = ""
                        let data = { ...self.formData }
                        url = "/ypt/admin/businessDatabase/info/save"
                        this.$http
                            .request({
                                url: url,
                                method: "POST",
                                data: {
                                    ...data,
                                },
                            })
                            .then((res) => {
                                if (res.code == 200) {
                                    this.$emit("cancleAddress", true)
                                    this.$message.success(res.message)
                                } else {
                                    this.$message.error(res.message)
                                }
                            })
                    }
                }
            })
        },
        dialogVisibleClone() {
            this.$emit("cancleAddress", false)
        },
    },
}
</script>
<style lang="less" scoped>
</style>